import script from "./delete-account.vue?vue&type=script&setup=true&lang=js"
export * from "./delete-account.vue?vue&type=script&setup=true&lang=js"

import "./delete-account.vue?vue&type=style&index=0&id=d720f216&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d720f216"]])

export default __exports__